import axios from '@/backend'

const state = {
  client: {},
  loading: false,
  saved: false
}

const getters = {
  client (state) {
    return state.client
  },
  isClientLoading (state) {
    return state.loading
  },
  isClientSaved (state) {
    return state.saved
  }
}

const mutations = {
  setClient (state, client) {
    state.client = client
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setSaved (state, saved) {
    state.saved = saved
  },
  updateCustomField (state, field) {
    state.client.custom_fields[field.name] = field.value
  }
}

const actions = {
  loadClient ({dispatch, commit}, clientId) {
    commit('setSaved', false)
    commit('setLoading', true)
    axios.get('/clients/' + clientId)
      .then(function (response) {
        commit('setClient', response.data)
        commit('setLoading', false)
      })
      .catch(e => { console.log(e) })
  },
  saveClient ({dispatch, commit}) {
    commit('setSaved', false)
    axios.put(
      ('/clients/' + state.client.external_client_id),
      {client: state.client}
    ).then(function (response) {
      commit('setClient', response.data)
      commit('setSaved', true)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/client.js